import { RATINGS } from '@common/constants'
import { Stars } from '@components/common/icons/custom-icons'
import { FastlyImage } from '@components/common/image'

const COMMON_IMAGE_PATH = '/images/common/partners/'

type RatingsProps = {
  isDarkText?: boolean
}

const Ratings = ({ isDarkText = false }: RatingsProps) => {
  return (
    <div className="flex space-x-8 items-center text-white">
      <div>
        <FastlyImage
          src={`${COMMON_IMAGE_PATH}google-medium.png`}
          webpSrc={`${COMMON_IMAGE_PATH}google-medium.webp`}
          width={60}
          height={20}
        />
        <Stars className="my-2" />
        <p className={`${isDarkText && 'text-grey'}`}>
          {RATINGS.GOOGLE_RATING.rating} / 5 stars
        </p>
      </div>
    </div>
  )
}
export default Ratings
